import { getHandlers } from '../utils.js'

const COMPRESSION_FIELDS = ['gzip']

const handleCompressionChange = (onChange, _, all) => {
  const options = all.filter((pair) => COMPRESSION_FIELDS.includes(pair[1])).map((pair) => pair[1])

  onChange({}, 'compression', options)
}

export default getHandlers(COMPRESSION_FIELDS, handleCompressionChange)
